import __request__ from "routing/request";
export function resolve(ids, requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.forwarder/forwarder/input/resolve", null, { "ids": ids }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getById(inputId, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.forwarder/forwarder/input/${inputId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
